/** Раздел E, деньги: пирамида, монета, акции, ломбард и микрозайм (E8–E10). */
import type { MinigameDef } from '../types';
import { crypto } from './crypto';
import { loans } from './loans';
import { pyramid } from './pyramid';
import { stocks } from './stocks';

export const MONEY_MINIGAMES: MinigameDef[] = [pyramid as MinigameDef, crypto as MinigameDef, stocks as MinigameDef, loans as MinigameDef];

export { pyramid, crypto, stocks, loans };
